import { Instance, types } from 'mobx-state-tree';

import Homework from '../Schedules/Homework';

const ClientHomework = types.compose(
	Homework,
	types.model('ClientHomework', {
		from_schedule_lesson: types.maybeNull(
			types.model({
				id: types.maybeNull(types.number),
				date: types.optional(types.string, ''),
				theme: types.maybeNull(types.string),
			}),
		),
	}),
);

export default ClientHomework;

export interface IClientHomeworkModel extends Instance<typeof ClientHomework> {}
